import { Routes } from '@angular/router';
import { PqrComponent } from './components/pqr/pqr.component';
import { AutenticacaoGuard } from "./guards/autenticacao.guard";
import { LoginComponent } from "./components/login/login.component";
import { HomeComponent } from './components/home/home.component';
import { SobreComponent } from './components/sobre/sobre.component';
import { ContatoComponent } from './components/contato/contato.component';
import { QualidadeComponent } from './components/qualidade/qualidade.component';
import { LayoutEditorComponent } from './layouts/layout-editor/layout-editor.component';
import { LayoutEdicaoComponent } from './layouts/layout-edicao/layout-edicao.component';
import { DesignSystemComponent } from './components/design-system/design-system.component';
import { RelatorioCaqComponent } from './components/relatorio-caq/relatorio-caq.component';
import { LayoutResultadoComponent } from './layouts/layout-resultado/layout-resultado.component';
import { LayoutPrincipalComponent } from './layouts/layout-principal/layout-principal.component';
import { SelecionarLocalComponent } from './components/selecionar-local/selecionar-local.component';
import { LayoutIndicadoresComponent } from './layouts/layout-indicadores/layout-indicadores.component';
import { ProjecaoDaOfertaComponent } from './components/projecao-da-oferta/projecao-da-oferta.component';
import { TamanhoDasTurmasComponent } from './components/tamanho-das-turmas/tamanho-das-turmas.component';
import { ResultadoProjecaoComponent } from './components/resultado-projecao/resultado-projecao.component';
import { NumeroProfessoresComponent } from './components/numero-professores/numero-professores.component';
import { CondicoesQualidadeComponent } from './components/condicoes-qualidade/condicoes-qualidade.component';
import { AdicionaisComponent, canDeactivateFnAdicionais } from './components/adicionais/adicionais.component';
import { DiagnosticoDeMatriculaComponent } from './components/diagnostico-de-matricula/diagnostico-de-matricula.component';
import { NumeroFuncionariosFuncaoComponent } from './components/numero-funcionarios-funcao/numero-funcionarios-funcao.component';
import { canDeactivateFnEncargosSociais, EncargosSociaisComponent } from './components/encargos-sociais/encargos-sociais.component';
import { RelatorioPrevisaoOrcamentariaComponent } from './components/relatorio-previsao-orcamentaria/relatorio-previsao-orcamentaria.component';
import { ResultadoPrevisaoOrcamentariaComponent } from './components/resultado-previsao-orcamentaria/resultado-previsao-orcamentaria.component';
import { AlimentacaoEscolarComponent, canDeactivateFnAlimentacaoEscolar } from './components/alimentacao-escolar/alimentacao-escolar.component';
import { canDeactivateFnCargaHoraria, CargaHorariaDeEnsinoComponent } from './components/carga-horaria-de-ensino/carga-horaria-de-ensino.component';
import { NumeroDeDiasLetivosComponent, canDeactivateFnNumeroDeDiasLetivos } from './components/numero-de-dias-letivos/numero-de-dias-letivos.component';
import { ManutencaoDasEscolasComponent } from './components/manutencao-das-escolas/manutencao-das-escolas.component';
import { RelatorioFinanciamentoDasEscolasComponent } from './components/relatorio-financiamento-das-escolas/relatorio-financiamento-das-escolas.component';
import { FinanciamentoAtualNecessarioApresentacaoWrapperComponent } from './components/financiamento-atual-necessario-apresentacao/financiamento-atual-necessario-apresentacao-wrapper.component';
import { CaqApresentacaoWrapperComponent } from './components/caq-apresentacao/caq-apresentacao-wrapper.component';
import { canDeactivateFn, CarreiraRemuneracaoProfessoresComponent, } from './components/carreira-remuneracao-professores/carreira-remuneracao-professores.component';
import { PlanejamentoOrcamentarioApresentacaoWrapperComponent } from './components/planejamento-orcamentario-apresentacao/planejamento-orcamentario-apresentacao-wrapper.component';
import { QuadroFuncionariosRemuneracaoComponent, canDeactivateQuadroFuncionariosFn } from './components/quadro-funcionarios-remuneracao/quadro-funcionarios-remuneracao.component';
import { IndicadoresLocaisComponent } from './components/indicadores-locais/indicadores-locais.component';
import {
  CustoPorEscolaApresentacaoWrapperComponent
} from "./components/custo-por-escola-apresentacao-wrapper/custo-por-escola-apresentacao-wrapper.component";
import {
  RelatorioCustoPorEscolaComponent
} from "./components/relatorio-custo-por-escola/relatorio-custo-por-escola.component";
import { EquipeComponent } from './components/equipe/equipe.component';
import { NovasSalasPrediosComponent } from './components/novas-salas-predios/novas-salas-predios.component';
import { RelatorioReceitasDespesasApresentacaoWrapperComponent } from './components/relatorio-receitas-despesas-apresentacao/relatorio-receitas-despesas-apresentacao-wrapper.component';
import { featureFlagGuard } from './guards/feature-flag.guard';
import {
  RelatorioReceitasDespesasComponent
} from './components/relatorio-receitas-despesas/relatorio-receitas-despesas.component';
import {
  canDeactivateFnFatorPonderacao,
  FatorPonderacaoComponent
} from "./components/fator-ponderacao/fator-ponderacao.component";

export const routes: Routes = [
  {
    path: '',
    component: LayoutPrincipalComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'pqr', component: PqrComponent },
      { path: 'sobre', component: SobreComponent },
      { path: 'home', component: HomeComponent },
      { path: 'contato', component: ContatoComponent },
      { path: 'equipe', component: EquipeComponent },
      { path: 'qualidade', component: QualidadeComponent },
      { path: 'selecionar-local', component: SelecionarLocalComponent },
      { path: 'selecionar-local-R5', component: SelecionarLocalComponent },
      { path: 'filtrar-instituicoes', component: SelecionarLocalComponent },
      { path: 'filtrar-escolas', component: SelecionarLocalComponent },
      { path: 'condicao-qualidade', component: CondicoesQualidadeComponent },
      { path: 'indicadores-locais', component: IndicadoresLocaisComponent },
      {
        path: 'planejamento-orcamentario-apresentacao',
        component: PlanejamentoOrcamentarioApresentacaoWrapperComponent,
      },
      { path: 'caq-apresentacao', component: CaqApresentacaoWrapperComponent },
      {
        path: 'financiamento-atual-necessario',
        component: FinanciamentoAtualNecessarioApresentacaoWrapperComponent,
      },
      {
        path: 'custo-por-escola-apresentacao',
        component: CustoPorEscolaApresentacaoWrapperComponent,
      },
      {
        path: 'relatorio-receitas-despesas-apresentacao',
        component: RelatorioReceitasDespesasApresentacaoWrapperComponent,
        canActivate: [
          featureFlagGuard('885-tela-apresentacao-relatorio-receitas-despesas'),
        ],
      },
      {
        path: 'resultado',
        component: LayoutResultadoComponent,
        children: [
          {
            path: 'projecao-orcamentaria',
            component: RelatorioPrevisaoOrcamentariaComponent,
          },
          {
            path: 'relatorio-caq',
            component: RelatorioCaqComponent,
          },
          {
            path: 'relatorio-financiamento-das-escolas',
            component: RelatorioFinanciamentoDasEscolasComponent,
          },
          {
            path: 'relatorio-custo-por-escola',
            component: RelatorioCustoPorEscolaComponent,
          },
          {
            path: 'relatorio-receitas-despesas',
            component: RelatorioReceitasDespesasComponent,
            canActivate: [
              featureFlagGuard('884-tela-relatorio-receitas-despesas'),
            ],
          },
        ]
      },
      {
        path: 'indicadores',
        component: LayoutIndicadoresComponent,
        children: [
          {
            path: 'orcamento-educacional',
            component: IndicadoresLocaisComponent,
          },
          {
            path: 'financiamento-atual-necessario',
            component: IndicadoresLocaisComponent,
          },
          {
            path: 'custo-por-escola',
            component: IndicadoresLocaisComponent,
          }
        ]
      },
      {
        path: 'edicao-relatorio-planejamento-orcamentario',
        component: LayoutEdicaoComponent,
        children: [
          {
            path: 'acesso-oferta-educacional',
            children: [
              {
                path: 'diagnostico-matricula',
                component: DiagnosticoDeMatriculaComponent,
              },
              {
                path: 'projecao-da-oferta',
                component: ProjecaoDaOfertaComponent,
              },
              {
                path: 'resultado-projecao',
                component: ResultadoProjecaoComponent,
              }
            ]
          },
          {
            path: 'condicao-qualidade',
            children: [
              {
                path: 'numero-de-dias-letivos',
                component: NumeroDeDiasLetivosComponent,
                canDeactivate: [canDeactivateFnNumeroDeDiasLetivos],
              },
              {
                path: 'carga-horaria-de-ensino',
                component: CargaHorariaDeEnsinoComponent,
                canDeactivate: [canDeactivateFnCargaHoraria],
              },
              {
                path: 'tamanho-das-turmas',
                component: TamanhoDasTurmasComponent,
              },
              {
                path: 'docente-formacao-remuneracao',
                component: CarreiraRemuneracaoProfessoresComponent,
                canDeactivate: [canDeactivateFn],
              },
              {
                path: 'quantidade-docente-etapa',
                component: NumeroProfessoresComponent,
              },
              {
                path: 'quadro-funcionarios-remuneracao',
                component: QuadroFuncionariosRemuneracaoComponent,
                canDeactivate: [canDeactivateQuadroFuncionariosFn],
              },
              {
                path: 'numero-funcionarios-funcao',
                component: NumeroFuncionariosFuncaoComponent,
              },
              {
                path: 'alimentacao-escolar',
                component: AlimentacaoEscolarComponent,
                canDeactivate: [canDeactivateFnAlimentacaoEscolar],
              },
              {
                path: 'servicos-infraestrutura-recursos',
                component: ManutencaoDasEscolasComponent,
              },
              {
                path: 'direitos-obrigacoes-trabalhistas',
                component: EncargosSociaisComponent,
                canDeactivate: [canDeactivateFnEncargosSociais],
              },
              {
                path: 'docente-adicional-remuneracao',
                component: AdicionaisComponent,
                canDeactivate: [canDeactivateFnAdicionais],
              },
              {
                path: 'fator-ponderacao',
                component: FatorPonderacaoComponent,
                canDeactivate: [canDeactivateFnFatorPonderacao]
              }
            ]
          },
          {
            path: 'infraestrutura-escolar',
            children: [
              {
                path: 'espacos-escolares-reforma-adequacao',
                component: NovasSalasPrediosComponent,
              },
            ],
          },
          {
            path: 'resultado-previsao-orcamentaria',
            component: ResultadoPrevisaoOrcamentariaComponent,
          }
        ]
      },
      {
        path: 'edicao-relatorio-financiamento-das-escolas',
        component: LayoutEdicaoComponent,
        children: [
          {
            path: 'acesso-oferta-educacional',
            children: [
              {
                path: 'diagnostico-matricula',
                component: DiagnosticoDeMatriculaComponent,
              },
              {
                path: 'projecao-da-oferta',
                component: ProjecaoDaOfertaComponent,
              },
              {
                path: 'resultado-projecao',
                component: ResultadoProjecaoComponent,
              }
            ]
          },
          {
            path: 'condicao-qualidade',
            children: [
              {
                path: 'numero-de-dias-letivos',
                component: NumeroDeDiasLetivosComponent,
                canDeactivate: [canDeactivateFnNumeroDeDiasLetivos],
              },
              {
                path: 'carga-horaria-de-ensino',
                component: CargaHorariaDeEnsinoComponent,
                canDeactivate: [canDeactivateFnCargaHoraria],
              },
              {
                path: 'tamanho-das-turmas',
                component: TamanhoDasTurmasComponent,
              },
              {
                path: 'docente-formacao-remuneracao',
                component: CarreiraRemuneracaoProfessoresComponent,
                canDeactivate: [canDeactivateFn],
              },
              {
                path: 'quantidade-docente-etapa',
                component: NumeroProfessoresComponent,
              },
              {
                path: 'quadro-funcionarios-remuneracao',
                component: QuadroFuncionariosRemuneracaoComponent,
                canDeactivate: [canDeactivateQuadroFuncionariosFn],
              },
              {
                path: 'numero-funcionarios-funcao',
                component: NumeroFuncionariosFuncaoComponent,
              },
              {
                path: 'alimentacao-escolar',
                component: AlimentacaoEscolarComponent,
                canDeactivate: [canDeactivateFnAlimentacaoEscolar],
              },
              {
                path: 'direitos-obrigacoes-trabalhistas',
                component: EncargosSociaisComponent,
                canDeactivate: [canDeactivateFnEncargosSociais],
              },
              {
                path: 'servicos-infraestrutura-recursos',
                component: ManutencaoDasEscolasComponent,
              },
              {
                path: 'docente-adicional-remuneracao',
                component: AdicionaisComponent,
                canDeactivate: [canDeactivateFnAdicionais],
              },
              {
                path: 'fator-ponderacao',
                component: FatorPonderacaoComponent,
                canDeactivate: [canDeactivateFnFatorPonderacao]
              }
            ]
          },
          {
            path: 'infraestrutura-escolar',
            children: [
              {
                path: 'espacos-escolares-reforma-adequacao',
                component: NovasSalasPrediosComponent,
              }
            ]
          }
        ]
      },
      {
        path: 'relatorio1',
        component: LayoutEditorComponent,
        children: [
          {
            path: 'condicao-qualidade',
            children: [
              {
                path: 'numero-de-dias-letivos',
                component: NumeroDeDiasLetivosComponent,
                canDeactivate: [canDeactivateFnNumeroDeDiasLetivos],
              },
              {
                path: 'docente-formacao-remuneracao',
                component: CarreiraRemuneracaoProfessoresComponent,
                canDeactivate: [canDeactivateFn],
              },
              {
                path: 'carga-horaria-de-ensino',
                component: CargaHorariaDeEnsinoComponent,
              },
              {
                path: 'tamanho-das-turmas',
                component: TamanhoDasTurmasComponent,
              },
              {
                path: 'quantidade-docente-etapa',
                component: NumeroProfessoresComponent,
              },
              {
                path: 'numero-funcionarios-funcao',
                component: NumeroFuncionariosFuncaoComponent,
              },
              {
                path: 'quadro-funcionarios-remuneracao',
                component: QuadroFuncionariosRemuneracaoComponent,
                canDeactivate: [canDeactivateQuadroFuncionariosFn],
              },
              {
                path: 'servicos-infraestrutura-recursos',
                component: ManutencaoDasEscolasComponent,
              },
              {
                path: 'alimentacao-escolar',
                component: AlimentacaoEscolarComponent,
              }
            ]
          },
          {
            path: 'infraestrutura-escolar',
            children: [
              {
                path: 'espacos-escolares-reforma-adequacao',
                component: NovasSalasPrediosComponent,
              }
            ]
          },
          {
            path: 'acesso-oferta-educacional',
            children: [
              {
                path: 'diagnostico-matricula',
                component: DiagnosticoDeMatriculaComponent,
              },
              {
                path: 'resultado-projecao',
                component: ResultadoProjecaoComponent,
              },
              {
                path: 'projecao-da-oferta',
                component: ProjecaoDaOfertaComponent,
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'design-system',
    component: DesignSystemComponent,
  },
  { path: 'login', component: LoginComponent },
];
